import React from 'react'
import { arrayOf } from 'prop-types'
import { Typography, styled, css } from '@mui/material'
import { currencyFormatUS } from '@helpers/string-helper'
import { getRequiredAddon, productPrice } from '@helpers/product'
import { AddonModelPropType } from '@models/api/products/addon-model'
import { PriceAtom } from '@rtgdev/design-system'

const AddToCartAddonsStyled = styled('div')(
  ({ theme }) => css`
    margin-bottom: 40px;
    @media only screen and (max-width: 768px) {
      padding-top: 16px
      border-top: 1px solid #dedede;
    }

    .AddToCartAddons {
      &__Item {
        line-height: 22px;
      }
      &__Price {
        margin-left: 3px;
        font-weight: 600;
        color: ${theme.palette.primary.dark};
      }
    }
  `,
)

const AddToCartAddons = props => {
  const { allActiveAddons = [], activeAddons = [] } = props
  const addons = allActiveAddons || activeAddons

  const getAddonsToDisplay = () => {
    const requiredAddons = addons?.filter(addon => addon?.addon_required)
    if (requiredAddons?.length < 1) {
      return addons
    }

    const requiredAddon = getRequiredAddon(requiredAddons)
    requiredAddon.sku = requiredAddon?.skus?.join()
    requiredAddon.isRequiredItemGroup = true

    const filteredAddons = addons?.filter(addon => !requiredAddon?.skus?.includes(addon?.sku))
    return [requiredAddon, ...filteredAddons]
  }

  return (
    <AddToCartAddonsStyled className="AddToCartAddons">
      <Typography variant="body1" fontWeight={500} marginBottom="10px">
        Selected Add-Ons:
      </Typography>
      {getAddonsToDisplay().map(product => (
        <p key={`product-addon-${product.sku}`} className="AddToCartAddons__Item">
          <span dangerouslySetInnerHTML={{ __html: product.title }} />
          {product.quantity > 1 && <span className="AddToCartAddons__Quantity">&nbsp;{product.quantity}</span>}
          &nbsp;-&nbsp;
          {product?.isRequiredItemGroup ? (
            <span className="AddToCartAddons__Price">
              <PriceAtom price={currencyFormatUS(product?.price)} />
            </span>
          ) : (
            <span className="AddToCartAddons__Price">
              <PriceAtom price={currencyFormatUS(productPrice(product) * product.quantity)} />
            </span>
          )}
        </p>
      ))}
    </AddToCartAddonsStyled>
  )
}

AddToCartAddons.propTypes = { allActiveAddons: arrayOf(AddonModelPropType), activeAddons: arrayOf(AddonModelPropType) }

export default AddToCartAddons
